// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "monthsWrapper-2cOoP";
var _4 = "monthsList-OrqAs";
var _5 = "wrapper-2vQI0";
var _6 = "frameless-3Bu3o";
var _7 = "nav_next-19DEu";
var _8 = "nav_prev-2cVx0";
export { _1 as "__esModule", _2 as "tablet", _3 as "monthsWrapper", _4 as "monthsList", _5 as "wrapper", _6 as "frameless", _7 as "nav_next", _8 as "nav_prev" }
export default { "__esModule": _1, "tablet": _2, "monthsWrapper": _3, "monthsList": _4, "wrapper": _5, "frameless": _6, "nav_next": _7, "nav_prev": _8 }
